<template>
    <div id="pageDashboard" >
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg6 sm6 xs12>
                    <MiniStatistic
                        icon="move_to_inbox"
                        :title="today_packs"
                        sub-title="Boxs"
                        color="indigo"
                        >
                    </MiniStatistic>
                </v-flex>
                <v-flex lg6 sm6 xs12>
                    <MiniStatistic
                        icon="local_shipping"
                        :title="today_send"
                        sub-title="Sended"
                        color="red"      
                    >
                    </MiniStatistic>           
                </v-flex>          
                <!-- <v-flex lg3 sm6 xs12>
                    <mini-statistic
                        icon="fa fa-twitter"
                        title="200+"
                        sub-title="Followers"
                        color="light-blue"      
                    >
                    </mini-statistic>            
                </v-flex>        
                <v-flex lg3 sm6 xs12>
                    <mini-statistic
                        icon="fa fa-instagram"
                        title="50+"
                        sub-title="Shots"
                        color="purple"      
                    >
                    </mini-statistic>             
                </v-flex> -->
              

         
                <!-- <v-flex lg8 sm12 xs12>
                    <v-widget title="Site Traffic" content-bg="white">
                        <v-btn icon slot="widget-header-action">
                            <v-icon class="text--secondary">refresh</v-icon>
                        </v-btn>
                    </v-widget>
                </v-flex>
                <v-flex lg4 sm12 xs12>
                    <v-widget title="Top Location" content-bg="white">
                    </v-widget>
                </v-flex> -->

<!--             
                <v-flex lg4 sm12 xs12>
                    <profile-card>
                    </profile-card>
                </v-flex>        
                <v-flex lg4 sm12 xs12>
                    
                    <box-chart
                        card-color="indigo"
                        title="Trending"
                        sub-title="10%"
                        icon="trending_up"
                        :data="siteTrafficData"
                        :chart-color="[color.indigo.lighten1]"
                        type="line"
                    >
                    </box-chart>
                    <box-chart class="mt-4"
                        card-color="pink"
                        title="Page views"
                        sub-title="10%"
                        icon="trending_up"
                        :data="siteTrafficData"
                        :chart-color="[color.pink.darken1, 'rgba(255,255,255,0.3)']"
                        gradient
                        type="area"
                    >
                    </box-chart>  
                   
                </v-flex>         
            
                <v-flex lg4 sm12 xs12>
                    <linear-statistic 
                        title="Sales"
                        sub-title="Sales increase"
                        icon="trending_up"
                        color="success"
                        :value="15"
                    >
                    </linear-statistic>
                    <linear-statistic class="my-4"
                        title="Orders"
                        sub-title="Increase"
                        icon="trending_up"
                        color="pink"
                        :value="30"
                    >
                    </linear-statistic>          
                    <linear-statistic class="my-4"
                        title="Revenue"
                        sub-title="Revenue increase"
                        icon="trending_up"
                        color="primary"
                        :value="50"
                    >
                    </linear-statistic>          
                    <linear-statistic class="mt-4"
                        title="Cost"
                        sub-title="Cost reduce"
                        icon="trending_down"
                        color="orange"
                        :value="25"
                    >
                    </linear-statistic>          
                </v-flex> -->
<!--          
                <v-flex lg4 sm12 xs12 v-for="(item,index) in trending" :key="'c-trending'+index">
                    <circle-statistic
                        :title="item.subheading"
                        :sub-title="item.headline"
                        :caption="item.caption"
                        :icon="item.icon.label"
                        :color="item.linear.color"
                        :value="item.linear.value"
                    >
                    </circle-statistic>            
                </v-flex>     -->

        
                <v-flex  lg6 sm6 xs12>
                    <plain-table></plain-table>
                </v-flex>
                 <v-flex  lg6 sm6 xs12>
                    <pick-by-user></pick-by-user>
                </v-flex>
                <!-- <v-flex lg6 sm12 xs12>
                    <v-widget title="Activities" contentBg="white">
                        <div slot="widget-content">
                        <ol class="timeline timeline-activity timeline-point-sm timeline-content-right">
                            <li class="timeline-block" v-for="(item, index) in activity" :key="index">
                            <div class="timeline-point">
                                <v-circle dot large :color="item.color"></v-circle>
                            </div>
                            <div class="timeline-content">
                                <time datetime="2018" class="subheading">{{item.timeString}}</time>
                                <div class="py-2 text--secondary" v-html="item.text"></div>
                            </div>
                            </li>
                        </ol>              
                        </div>
                    </v-widget>          
                </v-flex> -->
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
// import VWidget from '@/components/VWidget'; 
// import ProfileCard from '@/components/widgets/card/ProfileCard';
// import Material from 'vuetify/es5/util/colors';
// import VCircle from '@/components/circle/VCircle';
// import BoxChart from '@/components/widgets/chart/BoxChart';
// import CircleStatistic from '@/components/widgets/statistic/CircleStatistic';
// import LinearStatistic from '@/components/widgets/statistic/LinearStatistic';
// import UserService from '@/services/UserService'
import PlainTable from "@/components/widgets/list/PlainTable"
import PickByUser from "@/components/widgets/list/PickByUser"

import {mapActions } from 'vuex'
import DashboardService from "@/services/DashboardService";
export default {
    name: 'Dashboard',
    metaInfo: {
        title: 'Dashboard',
    },
    components: {
        // VWidget,
        MiniStatistic,
        PlainTable,
        PickByUser
        // VCircle,
        // ProfileCard,
        // CircleStatistic,
        // LinearStatistic,
        // BoxChart
    },
    data: () => ({
        today_packs: 0,
        today_send: 0,
    }),
    computed : {
    },
    methods: {
        ...mapActions('app', ['setTitleText']),
        async fetchDashboardData() {
            await DashboardService.getDashboardStatistic()
            .then(res => {
                if (res.success) {
                    this.today_packs = res.statistic[0].pack_today
                    this.today_send = res.statistic[0].send_today

                    setTimeout(() => {
                        this.fetchDashboardData();
                    }, 60000);
                }
            });
        }
    },
    created() {
        this.fetchDashboardData();
    },
    mounted(){

    }
}
</script>
